module.exports = __webpack_public_path__ + "img/banner_2026_skin_dress_prerelease.3baf837f.jpg";